import { registerComponent } from '@gig/magic-common';
import FaqEntryComponent from './faq-entry.vue.js';

var FaqEntry = registerComponent(FaqEntryComponent);

export { FaqEntry };
